import { Stack } from "@biblioteksentralen/react";
import { DefaultContainer } from "../ContentContainer";
import { Edit } from "../editInSanity/EditInSanity";
import { EmployeeViewContentWrapper } from "./EmployeeViewContent";
import EmployeeViewHeader from "./EmployeeViewHeader";
import { ResolvedEmployee, ResolvedListSummary, ResolvedRecommendationSummary } from "@libry-content/common";

interface Props {
  employee?: ResolvedEmployee;
  listsAndRecommendations: (ResolvedListSummary | ResolvedRecommendationSummary)[];
  total: number;
}

const EmployeeView = ({ employee, listsAndRecommendations, total }: Props) => {
  if (!employee || !employee.showEmployee) return null;

  return (
    <>
      <EmployeeViewHeader employee={employee} />
      <Edit doc={employee} />

      <DefaultContainer margin="2rem auto 5rem">
        <Stack gap="4rem">
          <EmployeeViewContentWrapper
            listsAndRecommendations={listsAndRecommendations}
            total={total}
            employee={employee}
          />
        </Stack>
      </DefaultContainer>
    </>
  );
};
export default EmployeeView;
